import { fromNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableModel } from '../../models/ValuableModel'

export class SchemaNumberModel extends ValuableModel {
  @fromNode()
  @reactive()
  maximum?: number

  @fromNode()
  @reactive()
  minimum?: number
}

declare global {
  export interface RehajeViewModels {
    'Schema.Number': SchemaNumberModel
  }
}
